export default __webpack_public_path__ + "static/hacktoberfest-2023-with-layer5-d75ad4f9d2094005dd4e683555130e23.png";